/*
 * Copyright (c) Qwoach LLC 2026. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import {FirestorePager} from "@qwoach/firebase-data-manager";
import DataFilter from "@/core/js/backend/filters/BaseDataFilter.js";

const DEFAULT_UNSPLASH_SEARCH_PAGE_SIZE = 12

export default class UnsplashSearchPager extends FirestorePager {

	currentPage = 0
	totalPages = 0
	total = 0
	query = ""

	constructor(dataManager, options = {}) {
		let perPage = options.perPage || DEFAULT_UNSPLASH_SEARCH_PAGE_SIZE
		super(null, new DataFilter(perPage), null, null, options)
		this.dataManager = dataManager
		this.query = options.query || ""
	}

	reset(query = this.query) {
		super.reset()
		this.currentPage = 0
		this.totalPages = 0
		this.total = 0
		this.query = query || ""
		return this
	}

	async next() {
		let resultsArray = []
		this.loadCounter++
		if(this.hasMore){
			let nextPage = this.currentPage + 1
			let response = await this.dataManager.apiGetBookImagesUnsplashSearch({
				query: this.query,
				page: nextPage,
				perPage: this.getLimit(),
			})
			resultsArray = this.processResult(response, nextPage)
		}
		return resultsArray
	}

	processResult(response = {}, nextPage) {
		let resultsArray = response.results || []
		this.total = response.total || 0
		this.totalPages = response.totalPages || 0
		this.currentPage = nextPage
		this.hasMore = this.currentPage < this.totalPages
		return resultsArray
	}
}
